import api from './api';

export async function getEvents() {
  const response = await api.get('/getEvents');
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function createEventDef(payload) {
  const response = await api.post('/createEventDef', payload);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function modifyEventDef(payload) {
  const response = await api.post('/modifyEventDef', payload);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function deleteEventDef(defId) {
  const response = await api.post('/deleteEventDef', { defId });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function createEventSlot(payload) {
  const response = await api.post('/createEventSlot', payload);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function modifyEventSlot(payload) {
  const response = await api.post('/modifyEventSlot', payload);
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}

export async function deleteEventSlot(slotId) {
  const response = await api.post('/deleteEventSlot', { slotId });
  if (response.data.error !== undefined) throw new Error(response.data.error);
  return response.data.result;
}
